document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); 

document.addEventListener("click", (e) => {
  const swatch = e.target.closest(".block-swatch");
  if (!swatch) return;

  document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
});


const drawer = document.querySelector("cart-drawer");

if(!drawer.querySelector(".bss-b2b-discount-code-wrapper")) {

}

if (drawer) {
  const observer = new MutationObserver(() => {
    if (!drawer.hasAttribute("open")) {
      window.dispatchEvent(new Event("scroll"));
    }
    if(!drawer.querySelector(".bss-b2b-discount-code-wrapper")) {
        KC.renderDC();
    }
   
  });
  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ["open"],
  });
}

if(window.location.pathname.includes("cart")) {
  setTimeout(() => {
    KC.renderDC();
  },1500)
}

